import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BoundingBox } from '@planitgeo/treeplotter-domain/lib/infrastructure/geo/geo.interface';

type IMapState = {
  center: number[] | null;
  zoom: number | null;
  selectedDisplayProperty: string | null;
  colorAssignments: Record<string, string>;
  shapeAssignments: Record<string, number>;
  initialBoundingBox: BoundingBox | null;
};

const initialState: IMapState = {
  center: null,
  zoom: null,
  selectedDisplayProperty: null, // Will be set dynamically based on available fields
  colorAssignments: {},
  shapeAssignments: {},
  initialBoundingBox: null,
};

const slice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    saveCenter(state: IMapState, action: { payload: number[] }) {
      return {
        ...state,
        center: action.payload,
      };
    },
    saveZoom(state: IMapState, action: { payload: number }) {
      return {
        ...state,
        zoom: action.payload,
      };
    },
    setColorProperty(state: IMapState, action: { payload: string }) {
      return {
        ...state,
        selectedDisplayProperty: action.payload,
        // Clear assignments when color property changes
        colorAssignments: {},
        shapeAssignments: {},
      };
    },
    setColorAssignment(state: IMapState, action: PayloadAction<{ value: string; color: string }>) {
      const { value, color } = action.payload;
      state.colorAssignments[value] = color;
    },
    setShapeAssignment(
      state: IMapState,
      action: PayloadAction<{ value: string; shapeIndex: number }>
    ) {
      const { value, shapeIndex } = action.payload;
      state.shapeAssignments[value] = shapeIndex;
    },
    clearAssignments(state: IMapState) {
      state.colorAssignments = {};
      state.shapeAssignments = {};
    },
    setInitialBoundingBox(state: IMapState, action: PayloadAction<BoundingBox | null>) {
      state.initialBoundingBox = action.payload;
    },
    clearinitialBoundingBox(state: IMapState) {
      state.initialBoundingBox = null;
    },
  },
});

const { reducer } = slice;

if (!reducer) {
  throw new Error('No reducer found for map');
}

// eslint-disable-next-line import/no-unused-modules
export { reducer, slice };
